import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import reducer from '../reducers/index';
import { queryData } from '../actions/index';
import errorsReducer from '../../../shared/redux/reducers/errors';


const withEinstein = function withEinstein(WrappedComponent) {
  const mapStateToProps = state => state;

  class EinsteinRecommendationComponent extends Component {
    static getDomId() {
      return WrappedComponent.getDomId();
    }

    static getStore() {
      const middleware = [thunk];
      const initialState = {
        fallbackData: { content: undefined },
        errors: [],
      };

      return createStore(
        combineReducers({
          fallbackData: reducer,
          errors: errorsReducer,
        }),
        initialState,
        applyMiddleware(...middleware),
      );
    }

    constructor(props) {
      super(props);
      const { delay, url } = WrappedComponent.getFallbackDetails();

      this.addEvents = this.addEvents.bind(this);
      this.removeEvents = this.removeEvents.bind(this);
      this.loadAsyncData = this.loadAsyncData.bind(this);
      this.getFallbackProductList = this.getFallbackProductList.bind(this);

      this.timeout = {};
      this.timeoutDelay = delay;
      this.productListsUrl = url;
      this.componentId = WrappedComponent.getDomId();
      this.state = { [this.componentId]: window.seMarketplace[this.componentId] };

      this.addEvents();
    }

    componentWillUnmount() {
      this.removeEvents();
    }

    getFallbackProductList() {
      const { dispatch } = this.props;

      this.removeEvents();
      dispatch(queryData(this.productListsUrl));
    }

    addEvents() {
      const { [this.componentId]: componentData } = this.state;
      const { fallbackData: { content } } = this.props;

      if (componentData === undefined && content === undefined) {
        if (this.productListsUrl) {
          this.timeout = setTimeout(this.getFallbackProductList, this.timeoutDelay);
        }
        window.addEventListener('seMarketplace.componentLoaded', this.loadAsyncData);
      }
    }

    removeEvents() {
      clearTimeout(this.timeout);
      window.removeEventListener('seMarketplace.componentLoaded', this.loadAsyncData);
    }

    loadAsyncData({ detail: { componentId } }) {
      if (componentId === this.componentId) {
        this.removeEvents();
        this.setState({ [this.componentId]: window.seMarketplace[this.componentId] });
      }
    }

    render() {
      const { fallbackData: { content } } = this.props;
      const { [this.componentId]: componentData } = this.state;
      const combinedData = {
        ...this.props,
        ...componentData,
        ...content,
      };

      return <WrappedComponent {...combinedData} />;
    }
  }

  EinsteinRecommendationComponent.propTypes = {
    dispatch: PropTypes.func.isRequired,
    fallbackData: PropTypes.shape({}).isRequired,
  };

  return connect(mapStateToProps)(EinsteinRecommendationComponent);
};

export default withEinstein;
